import React, { useState } from "react";

export default function BricksCalculator() {
  const [wall9, setWall9] = useState({ length: "", height: "" });
  const [wall45, setWall45] = useState({ length: "", height: "" });
  const [doors, setDoors] = useState([{ width: "", height: "" }]);
  const [windows, setWindows] = useState([{ width: "", height: "" }]);
  const [totalBricks, setTotalBricks] = useState(null);

  // ✅ Brick volume with standard 10mm mortar (in cubic meters)
  const brickWithMortarVolume = 0.00256; // per brick
  const bricksPerCubicMeter = 1 / brickWithMortarVolume; // ≈ 390 bricks/m³

  const handleAddDoor = () => setDoors([...doors, { width: "", height: "" }]);
  const handleAddWindow = () =>
    setWindows([...windows, { width: "", height: "" }]);

  const handleDoorChange = (i, field, val) => {
    const copy = [...doors];
    copy[i][field] = val;
    setDoors(copy);
  };
  const handleWindowChange = (i, field, val) => {
    const copy = [...windows];
    copy[i][field] = val;
    setWindows(copy);
  };

  const handleCalculate = () => {
    const ftToM = 0.3048;

    const wall9Length = parseFloat(wall9.length) * ftToM;
    const wall9Height = parseFloat(wall9.height) * ftToM;
    const wall45Length = parseFloat(wall45.length) * ftToM;
    const wall45Height = parseFloat(wall45.height) * ftToM;

    // Wall thickness in meters
    const t9 = 0.2286; // 9-inch wall
    const t45 = 0.1143; // 4.5-inch wall

    // Wall volumes
    const wall9Vol = wall9Length * wall9Height * t9;
    const wall45Vol = wall45Length * wall45Height * t45;

    // Openings volume
    let openingsVol = 0;
    doors.forEach((d) => {
      openingsVol +=
        (parseFloat(d.width) || 0) * ftToM *
        (parseFloat(d.height) || 0) * ftToM *
        t9; // assume door in 9-inch wall
    });
    windows.forEach((w) => {
      openingsVol +=
        (parseFloat(w.width) || 0) * ftToM *
        (parseFloat(w.height) || 0) * ftToM *
        t45; // assume window in 4.5-inch wall
    });

    const netVol = wall9Vol + wall45Vol - openingsVol;

    // ✅ Standard mortar included automatically (1m³ = 390 bricks)
    const total = netVol * bricksPerCubicMeter;

    setTotalBricks(total.toFixed(0));
  };

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>Brick Quantity Calculator</h2>

      <div style={gridStyle}>
        <div style={colStyle}>
          <label style={labelStyle}>9-inch Wall Length (ft)</label>
          <input
            type="number"
            value={wall9.length}
            onChange={(e) => setWall9({ ...wall9, length: e.target.value })}
            style={inputStyle}
          />
        </div>
        <div style={colStyle}>
          <label style={labelStyle}>9-inch Wall Height (ft)</label>
          <input
            type="number"
            value={wall9.height}
            onChange={(e) => setWall9({ ...wall9, height: e.target.value })}
            style={inputStyle}
          />
        </div>
      </div>

      <div style={gridStyle}>
        <div style={colStyle}>
          <label style={labelStyle}>4.5-inch Wall Length (ft)</label>
          <input
            type="number"
            value={wall45.length}
            onChange={(e) => setWall45({ ...wall45, length: e.target.value })}
            style={inputStyle}
          />
        </div>
        <div style={colStyle}>
          <label style={labelStyle}>4.5-inch Wall Height (ft)</label>
          <input
            type="number"
            value={wall45.height}
            onChange={(e) => setWall45({ ...wall45, height: e.target.value })}
            style={inputStyle}
          />
        </div>
      </div>

      <h3 style={{ marginTop: 20, fontWeight: 600 }}>Doors</h3>
      {doors.map((d, i) => (
        <div style={gridStyle} key={i}>
          <input
            type="number"
            placeholder="Width (ft)"
            value={d.width}
            onChange={(e) => handleDoorChange(i, "width", e.target.value)}
            style={inputStyle}
          />
          <input
            type="number"
            placeholder="Height (ft)"
            value={d.height}
            onChange={(e) => handleDoorChange(i, "height", e.target.value)}
            style={inputStyle}
          />
        </div>
      ))}
      <button onClick={handleAddDoor} style={smallBtnStyle}>
        + Add Door
      </button>

      <h3 style={{ marginTop: 20, fontWeight: 600 }}>Windows</h3>
      {windows.map((w, i) => (
        <div style={gridStyle} key={i}>
          <input
            type="number"
            placeholder="Width (ft)"
            value={w.width}
            onChange={(e) => handleWindowChange(i, "width", e.target.value)}
            style={inputStyle}
          />
          <input
            type="number"
            placeholder="Height (ft)"
            value={w.height}
            onChange={(e) => handleWindowChange(i, "height", e.target.value)}
            style={inputStyle}
          />
        </div>
      ))}
      <button onClick={handleAddWindow} style={smallBtnStyle}>
        + Add Window
      </button>

      <button onClick={handleCalculate} style={buttonStyle}>
        Calculate Bricks
      </button>

      {totalBricks && (
        <div style={{
  marginTop: 20,
  backgroundColor: "#e6f7ff",  // soft blue background
  padding: 20,
  borderRadius: 10,
  textAlign: "center",
  border: "2px solid #00aaff", // bright blue border
  fontWeight: "bold",
  color: "#005566", // dark teal text
  boxShadow: "0 4px 10px rgba(0, 170, 255, 0.2)"
}}>
  <h3 style={{ fontSize: 20, marginBottom: 6 }}>
    Total Bricks Required: <span style={{ color: "#28a745" }}>{totalBricks}</span> bricks
  </h3>
  <p style={{ fontSize: 14, fontWeight: "normal", color: "#004455" }}>
    (Including standard 10 mm mortar joints)
  </p>
</div>


      )}
    </div>
  );
}

// --- Styles (same as DeliveryCalculator) ---
const containerStyle = {
  maxWidth: 800,
  margin: "20px auto",
  padding: 24,
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
};
const titleStyle = {
  fontSize: 24,
  fontWeight: 600,
  marginBottom: 16,
  textAlign: "center",
  color: "#333",
};
const labelStyle = { fontWeight: 500, color: "#555", marginBottom: 4 };
const gridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 16,
  marginBottom: 12,
};
const colStyle = { display: "flex", flexDirection: "column" };
const inputStyle = {
  padding: 10,
  borderRadius: 8,
  border: "1px solid #ccc",
  fontSize: 14,
  outline: "none",
  width: "100%",
};
const buttonStyle = {
  width: "100%",
  padding: 12,
  background: "#007bff",
  color: "#fff",
  fontSize: 16,
  fontWeight: 500,
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  marginTop: 20,
};
const smallBtnStyle = {
  background: "#e6f4ff",
  color: "#007bff",
  padding: "6px 12px",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  marginBottom: 10,
};
const resultBox = {
  marginTop: 20,
  backgroundColor: "#f9f9f9",
  padding: 16,
  borderRadius: 8,
  textAlign: "center",
};
